import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { faAward, faFacePensive } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import FocusLock from 'react-focus-lock';
import { useTranslation } from 'react-i18next';

import './FinishedChallenge.css';
import { Confetti } from '../../contentTypes/components/Confetti';
import completeImg from '../../contentTypes/images/complete.png';
import { Button } from '../../shared/components/button/Button';
import { bringFocusToChallengeNavBtn } from '../../shared/util/challenges';

interface FinishedChallengeProps {
  title: string;
  subtitle: string;
  onClose: () => void;
  isSuccess: boolean;
}

function FinishedChallenge({ title, subtitle, onClose, isSuccess }: FinishedChallengeProps) {
  const { t } = useTranslation();
  const [confettiActive, setConfettiActive] = useState(true);

  useEffect(() => {
    setConfettiActive(true);
    setTimeout(() => {
      setConfettiActive(false);
    }, 10000);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
    // onClose wraps a stable setState setter; this modal only mounts when shown,
    // so registering the listener once per mount is the intended behaviour.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FocusLock returnFocus={bringFocusToChallengeNavBtn}>
      <div className="popup-overlay" role="dialog" aria-modal="true">
        <span className="sr-only">{t('modal.challenge.finished')}</span>
        {confettiActive && isSuccess && <Confetti isActive={confettiActive} />}
        <div className="dark-container finishedChallenge">
          <FontAwesomeIcon icon={isSuccess ? faAward : faFacePensive} className="icon award" />
          {isSuccess && <img src={completeImg} alt="`Complete` in large colourful font" />}
          <h2
            className={`finishedChallenge-header ${
              isSuccess ? 'finishedChallenge-header-success' : 'finishedChallenge-header-nosuccess'
            }`}
          >
            {title}
          </h2>
          <div className="finishedChallenge-subtitile">{subtitle}</div>
          <Button
            onClick={onClose}
            color="white"
            icon={{ faIconDefinition: faArrowRight, size: 'lg' }}
          >
            {t('M012')}
          </Button>
        </div>
      </div>
    </FocusLock>
  );
}

export default FinishedChallenge;
